import RestResource from '../rest.service';
export default class CoveragesService extends RestResource {
  constructor(api) {
    super(api, 'coverages', 'api');
  }
}
